import React, { useEffect, useState } from 'react';
import { TextField, Checkbox, FormControlLabel, Grid } from '@mui/material';
import { useDispatch ,useSelector} from 'react-redux';
import { createArticle ,updateArticle, fetchArticles ,clearAlerts,clearSelectedArticle} from '../../store/articleSlice'
// import { useSnackbar } from '../MySnackbar';
import MyButton from '../MyButton';
import { ACTION_PERMISSIONS } from "../../services/Enums";



const ArticleForm = ({closeDialog}) => {

  const dispatch = useDispatch();
  // const showSnackbar = useSnackbar();
  const {message,error,selectedArticle}=useSelector((state) => state.article);

  useEffect(() => {
   
    return () => {

          dispatch(clearAlerts());
          dispatch(clearSelectedArticle())
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  useEffect(() => {
  
      // Clear the form and fetch articles if successful
      if (message) {
        clearForm();
        dispatch(clearAlerts())
        dispatch(fetchArticles({ page: 1, limit: 5 }));
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  , [message, error]);


  const [formData, setFormData] = useState(() => ({
    id: selectedArticle?._id ||-1 ,
    code: selectedArticle?.code || '',
    name: selectedArticle?.name || '',
    price_r: selectedArticle?.price_r || 0,
    price_v: selectedArticle?.price_v || 0,
    isVisible: selectedArticle?.isVisible ?? true, // Ensure boolean values default to true
    weight: selectedArticle?.weight || 0,
    securityStock: selectedArticle?.securityStock || 0,
    isAlowSecondaryUnit: selectedArticle?.isAlowSecondaryUnit?? true,
    unitsQte:selectedArticle?.unitsQte||1,
    primaryUnits:selectedArticle?.primaryUnits || '',
    secondaryUnits: selectedArticle?.secondaryUnits || '',
  }));

  const clearForm =()=>{
      setFormData({
            id:-1,
            code: '',
            name: '',
            price_r: '',
            price_v: '',
            isVisible:true,
            weight: '',
            securityStock: '',
            isAlowSecondaryUnit:true, 
            unitsQte: 1,
            primaryUnits:'',
            secondaryUnits:'',
      })
  } 

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if(selectedArticle){
      dispatch(updateArticle(formData));
    }else{
      dispatch(createArticle(formData));
    }
    // showSnackbar("sucess", 'success');

  };

  // const handleOnClose = async (e) => {
  //   e.preventDefault();
  //   dispatch(clearSelectedArticle())
  //    closeDialog();
  // };

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Code"
            name="code"
            value={formData.code}
            onChange={(e)=>{handleChange(e)}}
            fullWidth
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Name"
            name="name"
            value={formData.name}
            onChange={(e)=>{handleChange(e)}}
            fullWidth
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Price (R)"
            name="price_r"
            value={formData.price_r}
            onChange={(e)=>{handleChange(e)}}
            type="number"
            fullWidth
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Price (V)"
            name="price_v"
            value={formData.price_v}
            onChange={(e)=>{handleChange(e)}}
            type="number"
            fullWidth
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Weight"
            name="weight"
            value={formData.weight}
            onChange={(e)=>{handleChange(e)}}
            type="number"
            fullWidth
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Security Stock"
            name="securityStock"
            value={formData.securityStock}
            onChange={(e)=>{handleChange(e)}}
            type="number"
            fullWidth
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="nombre de pieces"
            name="unitsQte"
            value={formData.unitsQte}
            onChange={(e)=>{handleChange(e)}}
            type="number"
            fullWidth
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="unite primaire"
            name="primaryUnits"
            value={formData.primaryUnits}
            onChange={(e)=>{handleChange(e)}}
            fullWidth
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="unite secondaire"
            name="secondaryUnits"
            value={formData.secondaryUnits}
            onChange={(e)=>{handleChange(e)}}
            fullWidth
            
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControlLabel
            control={
              <Checkbox
                checked={formData.isVisible}
                onChange={(e)=>{handleChange(e)}}
                name="isVisible"
                color="primary"
              />
            }
            label="Visible"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={formData.isAlowSecondaryUnit}
                onChange={(e)=>{handleChange(e)}}
                name="isAlowSecondaryUnit"
                color="primary"
              />
            }
            label="Autorise vente details"
          />
        </Grid>
        {/* <Grid item xs={12} sm={6}>
          <Button  variant="contained" color="secondary" fullWidth
          onClick={(e)=>{handleOnClose(e)}}>
           Discard
          </Button>
        </Grid> */}
        <Grid item xs={12} sm={12}>

          <MyButton
          type={"create"}
          action={ACTION_PERMISSIONS.ADD_ARTICLE}
          onClick={(e)=>{handleSubmit(e)}}
          />
          {/* <Button type="submit" variant="contained" color="primary" fullWidth>
            {selectedArticle?"Update article":"Create Article"}
          </Button> */}
        </Grid>
      </Grid>
    </form>
  );
};

export default ArticleForm;
